import { LoadState } from "../../../constants/enums";
import { ICampaignReportsState } from "./CampaignReports.types";

export const InitialCampaignReportsReduxState: ICampaignReportsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
